import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsGiftLogQuery implements ICommand
{

	public FromDate : string = "";
	public ToDate : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.FromDate = ba.readString();
		this.ToDate = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeString(this.FromDate);
		ba.writeString(this.ToDate);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsGiftLogQuery();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'FromDate(S)='+this.FromDate+' ';
		str += 'ToDate(S)='+this.ToDate+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55102;
	}

	public getCmdName() : string
	{
		return 'PsGiftLogQuery';
	}

}
